import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {JDate} from "ngx-persian";
import moment, {locale} from "moment";
import {GlobalService} from "../services/global.service";
enum JDateFormat {            // eslint-disable-line no-shadow
  SHORT = 'yy/m/d h:M t',
  SHORT_DATE = 'yy/m/d h:M t',
  MEDIUM = 'd mmm yyyy، h:M t',
  MEDIUM_DATE = 'd mmm yyyy، h:M t',
  LONG = 'd mmm yyyy، h:M:S T',
  LONG_DATE = 'd mmm yyyy، h:M:S T',
  SHORT_TIME = 'h:M t',
  MEDIUM_TIME = 'h:M:S t',
  LONG_TIME = 'h:M:S.l T',
}

@Pipe({
  name: 'dateText',
  standalone:true
})
export class DateTextPipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) public locale: string,public global: GlobalService) {
  }
  /**
   * Checks if `formatName` is in the `FormatNames` enum. If it is, returns related format string. Else returns `formatName` string
   * without any change.
   *
   * @param formatName format name or format pattern string
   * @return formatting pattern string
   */
  private static convertNameToFormat(formatName: keyof typeof JDateFormat): string {
    if (!JDateFormat[formatName]) {
      return formatName;
    }
    return JDateFormat[formatName];
  }

  /**
   * Formatting the date using `format` method of it with proper formatting pattern created from `format`
   *
   * @param value a Jalali Date object or an instance of `Date` object or any class implementing that interface
   * @param format format name or format pattern string
   */
  transform(value: number, format: string = 'MEDIUM_DATE'): string {
    let inputValue;
    if(format=="" ){
      format="yyyy/mm/dd";
    }

    if(this.locale=='fa') {

      // if (!(inputValue instanceof JDate)) {
      //   inputValue = new JDate(inputValue);
      // }
      inputValue = new JDate(value);
      // @ts-ignore
      return inputValue.format(DateTextPipe.convertNameToFormat(format));
    }else{
      format=format.replace("yyyy/mm/dd","yyyy/MM/DD");
      inputValue = new Date(value);
      return  moment(inputValue).format(format);
    }

  }

}

